export default __webpack_public_path__ + "static/media/mobile.a859a5dd.svg";